import React from 'react';
import classNames from 'classnames';
import styles from './Badge.module.scss';
/** Mirrors `BadgePriority` from `wix-ui-tpa/cssVars` (types.js) — all four values. */
export const BadgePriority = {
    default: 'default',
    light: 'light',
    primary: 'primary',
    secondary: 'secondary',
};
/**
 * Drop-in replacement for `Badge` from `wix-ui-tpa/cssVars`.
 *
 * DOM and defaults follow WUT (`Badge.js` -> `BadgeBase`):
 *  - `<div class="root [withIcon] priority">` wrapping `<div class="innerContainer">`, with an
 *    optional `<div class="icon" data-hook="badge-icon">` inside it.
 *  - `priority` defaults to `default`, not `primary`, and the enum has four values.
 *  - `data-priority` is emitted as WUT does.
 */
export const Badge = ({ className, priority = BadgePriority.default, icon, children, ...rest }) => (React.createElement("div", { ...rest, "data-priority": priority, className: classNames(styles.root, 
    /* `priority-${priority}`, prefixed as the sheet defines it — a bare `styles[priority]`
       resolved to undefined, so every badge rendered with the default priority's look.
       `default` has no class of its own: it is the base rule. */
    priority === BadgePriority.default ? undefined : styles[`priority-${priority}`], { [styles.withIcon]: !!icon }, className) },
    React.createElement("div", { className: styles.innerContainer },
        icon && (React.createElement("div", { "data-hook": "badge-icon", "data-part": "icon", className: styles.icon }, icon)),
        children)));
//# sourceMappingURL=Badge.js.map